<template>
    <Page withNavbar :withNavigation="withNavigation">
        <header>
            <section class="picture">
                <Video
                    v-if="video"
                    :src="video"
                    :ratio="1"
                />
                <Picture
                    v-else
                    :src="picture || config.BRIEF_IMAGE_MOBILE || config.BRIEF_IMAGE"
                    :ratio="1"
                    :size="pictureSize"
                    :color="pictureColor"
                />
            </section>
        </header>
        <main>
            <section class="text">
                <h4>{{ title || config.BRIEF_TITLE }}</h4>
                <p v-html="description || config.BRIEF_DESCRIPTION"/>
            </section>
            <SectionNavigation :to="{ name: next }"/>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { Page, SectionNavigation } from '../../components/mobile';

export default {
    name: 'BriefInfo',
    components: { Page, SectionNavigation },
    mixins: [SolutionConsumer],
    props: {
        next: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null,
        },
        video: {
            type: String,
            default: null,
        },
        picture: {
            type: String,
            default: null,
        },
        pictureCover: {
            type: Boolean,
            default: false,
        },
        pictureColor: {
            type: String,
            default: null,
        },
        withNavigation: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        pictureSize () {
            return this.pictureCover ? 'cover' : 'contain';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(40px 20px);
}
</style>
